import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { authProvider, tokenRequest } from '../../helpers/msal';

export const axiosInstance = axios.create();
axiosInstance.interceptors.request.use(
    async config => {
        const accounts = authProvider.getAllAccounts();
        const account = accounts[0];
        if (!account) {
            return config;
        }
        const accesToken = (await authProvider.acquireTokenSilent({ ...tokenRequest, account })).accessToken;
        config.headers.Authorization = `Bearer ${accesToken}`;
        config.headers.crossDomain = true;
        config.withCredentials = true;

        return config;
    },
    error => {
        console.log(`Request has failed`, error);
        Promise.reject(error);
    },
);

type RetryRequestConfig = AxiosRequestConfig & { _retry: boolean };
axiosInstance.interceptors.response.use(response => {
    return response;
}, handleRequestError);

async function handleRequestError(error: any) {
    console.log('Intercepting erronous request', error.config);
    const originalRequest: RetryRequestConfig = error.config;
    await transformBlobRequestsErrorResponse(originalRequest, error);

    if (error?.response?.status === 401 && !originalRequest._retry) {
        console.log('Unauthorized refreshing token');
    } else {
        console.log('Request has failed due to invalid data send or server error', error);
    }
    return Promise.reject(error);
}

const transformBlobRequestsErrorResponse = async (request: RetryRequestConfig, error: AxiosError) => {
    if (request.responseType === 'blob' && error.response?.data instanceof Blob) {
        try {
            error.response.data = JSON.parse(await error.response.data.text());
        } catch (e) {
            console.log('Request response is not a JSON, cannot transform to json form.', e);
        }
    }
};
